module.exports = __webpack_public_path__ + "static/img/bg1.a2f1e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/nyf/head/bg1.png
// module id = Vs7I
// module chunks = 1 12 18